import {
  Globe,
  Smartphone,
  ShoppingCart,
  Search,
  Wrench,
  Palette,
  Share2,
  TrendingUp,
} from "lucide-react";

export const serviceDetails = {
  "site-internet": {
    title: "Création de site internet",
    icon: Globe,
    description:
      "Nous concevons des sites internet modernes, rapides et pensés pour convertir vos visiteurs en clients.",
    intro:
      "Que vous ayez besoin d’un site vitrine, institutionnel ou d’une landing page, nous créons une présence en ligne professionnelle, cohérente avec votre image et adaptée à vos objectifs.",
    benefits: [
      "Renforcer votre présence en ligne",
      "Présenter vos services de manière claire",
      "Améliorer votre crédibilité",
      "Générer plus de contacts qualifiés",
    ],
    features: [
      "Design sur mesure",
      "Responsive mobile, tablette et desktop",
      "Structure pensée pour la conversion",
      "Optimisation SEO de base",
      "CMS simple à administrer",
      "Accompagnement personnalisé",
    ],
  },

  applications: {
    title: "Développement d'applications",
    icon: Smartphone,
    description:
      "Nous développons des applications web et mobiles adaptées à vos besoins métier et à vos utilisateurs.",
    intro:
      "Qu’il s’agisse d’un outil interne, d’une plateforme client ou d’une application mobile, nous concevons des solutions performantes, intuitives et évolutives.",
    benefits: [
      "Automatiser certaines tâches",
      "Améliorer l’expérience utilisateur",
      "Centraliser vos données",
      "Créer un outil adapté à votre activité",
    ],
    features: [
      "Applications web sur mesure",
      "Applications mobiles",
      "PWA",
      "Intégrations API",
      "Architecture évolutive",
      "Interface claire et moderne",
    ],
  },

  "e-commerce": {
    title: "E-commerce",
    icon: ShoppingCart,
    description:
      "Nous créons des boutiques en ligne complètes et performantes pour vendre efficacement vos produits.",
    intro:
      "De la mise en place du catalogue à la configuration du paiement et de la livraison, nous vous accompagnons dans la création d’une boutique en ligne pensée pour la conversion.",
    benefits: [
      "Vendre en ligne efficacement",
      "Faciliter la gestion de vos produits",
      "Offrir une expérience d’achat fluide",
      "Développer votre chiffre d’affaires",
    ],
    features: [
      "Shopify ou WooCommerce",
      "Catalogue produit structuré",
      "Paiement sécurisé",
      "Gestion des stocks",
      "Tunnel de commande optimisé",
      "Tableau de bord simple à utiliser",
    ],
  },

  seo: {
    title: "SEO / Référencement",
    icon: Search,
    description:
      "Nous mettons en place des stratégies SEO pour améliorer votre visibilité sur Google et attirer un trafic qualifié.",
    intro:
      "Le référencement naturel vous permet de gagner en visibilité durablement. Nous travaillons la technique, la structure et le contenu de votre site pour renforcer votre positionnement.",
    benefits: [
      "Améliorer votre visibilité sur Google",
      "Attirer un trafic qualifié",
      "Renforcer votre présence locale ou nationale",
      "Créer une stratégie durable",
    ],
    features: [
      "Audit SEO",
      "Optimisation technique",
      "Stratégie de contenu",
      "Travail des mots-clés",
      "Amélioration de la structure",
      "Suivi des performances",
    ],
  },

  maintenance: {
    title: "Maintenance & Support",
    icon: Wrench,
    description:
      "Nous assurons le suivi technique de votre site pour garantir sa stabilité, sa sécurité et sa performance.",
    intro:
      "Un site internet doit être entretenu régulièrement pour rester fiable. Nous proposons un accompagnement technique pour prévenir les problèmes et réagir rapidement en cas de besoin.",
    benefits: [
      "Garder un site à jour",
      "Réduire les risques techniques",
      "Améliorer la sécurité",
      "Bénéficier d’un support réactif",
    ],
    features: [
      "Mises à jour régulières",
      "Sauvegardes",
      "Monitoring",
      "Support technique",
      "Corrections mineures",
      "Suivi technique global",
    ],
  },

  branding: {
    title: "Branding & Identité",
    icon: Palette,
    description:
      "Nous créons une identité visuelle forte et cohérente pour valoriser votre entreprise et votre positionnement.",
    intro:
      "Votre image de marque joue un rôle essentiel dans la perception de votre activité. Nous vous aidons à construire un univers visuel professionnel, lisible et mémorable.",
    benefits: [
      "Renforcer votre image de marque",
      "Créer une identité cohérente",
      "Inspirer confiance",
      "Vous démarquer de la concurrence",
    ],
    features: [
      "Création de logo",
      "Charte graphique",
      "Supports de communication",
      "Refonte d’identité",
      "Direction artistique",
      "Cohérence multi-supports",
    ],
  },

  "reseaux-sociaux": {
    title: "Réseaux sociaux",
    icon: Share2,
    description:
      "Nous vous aidons à structurer votre présence sur les réseaux sociaux et à engager votre communauté.",
    intro:
      "Une présence cohérente sur les réseaux sociaux permet de gagner en visibilité, de renforcer votre image et de créer du lien avec votre audience.",
    benefits: [
      "Développer votre visibilité",
      "Créer plus d’engagement",
      "Améliorer votre image de marque",
      "Animer votre communauté",
    ],
    features: [
      "Stratégie éditoriale",
      "Création de contenu",
      "Community management",
      "Campagnes sponsorisées",
      "Calendrier de publication",
      "Suivi des performances",
    ],
  },

  marketing: {
    title: "Marketing digital",
    icon: TrendingUp,
    description:
      "Nous mettons en place des actions marketing pour attirer plus de visiteurs, générer des leads et améliorer vos conversions.",
    intro:
      "Le marketing digital permet d’accélérer votre croissance grâce à des leviers mesurables et adaptés à vos objectifs business.",
    benefits: [
      "Augmenter votre visibilité",
      "Générer plus de leads",
      "Mieux piloter vos actions",
      "Améliorer vos conversions",
    ],
    features: [
      "Google Ads",
      "Email marketing",
      "Analytics",
      "Optimisation conversion",
      "Suivi des résultats",
      "Stratégie d’acquisition",
    ],
  },
};